const parseParameters = (queryString) => {
  if (typeof queryString !== 'string') {
    return {};
  }
  const queryArray = queryString.replace(/^\?/, '').split('&');
  // check if was empty after ? was removed from string, since if so
  // queryArray will be [""], not []
  if (queryArray.length === 1 && queryArray[0] === '') {
    return {};
  }
  const decodeUri = window.decodeURIComponent;

  return queryArray.reduce((queryMap, entry) => {
    const entrySplit = entry.split('=');
    const paramKey = entrySplit[0];
    const paramValue = entrySplit[1] || '';
    queryMap[decodeUri(paramKey)] = decodeUri(paramValue);
    return queryMap;
  }, {});
};

export default parseParameters;
